
import {
  IconInfo,
  RevLink,
  RevPopover,
  RevTag,
  RevTooltip,
} from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'

import translations from './GradeDescription.translations'

export default {
  components: {
    RevLink,
    IconInfo,
    RevPopover,
    RevTag,
    RevTooltip,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    grade: {
      type: String,
      default: '',
    },
    details: {
      type: Array,
      required: true,
    },
  },
  computed: {
    translations: () => translations,

    disabledColorClass() {
      return { 'text-grey-400': this.disabled }
    },

    hasGrade() {
      return !isEmpty(this.grade)
    },
    tooltipModifiers() {
      return [
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top'],
          },
        },
      ]
    },
  },
}
